import React from 'react'
import '../css/footer.css'

function Footer() {
  return (
    <>
    <div className='footer text-center mt-5'>
        <p className='mx-2'>Copyright © 2022 <span>Raahgiri Foundation</span>. All Rights Reserved</p>
        <p className='mx-3'>Project by <span>Leaflets</span> (a unit of IAMPIX TECHNOLOGY PVT LTD).</p>
    </div>
    </>
  )
}

export default Footer